// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604281304/js/" + chunkId + "." + {"44":"c6e88e6e","225":"51431b2b","481":"80994a2b","486":"6f3c1806","770":"a81cc0d6"}[chunkId] + ".0.6086836347161451.chunk.js";
};